(function(){
  if (window.__f5jsLoaded) return; window.__f5jsLoaded = true;
  function mapNormalizedPoint(point, rect){
    return [point[0] * rect.width, point[1] * rect.height];
  }
  window.__f5MapNormalizedPoint = mapNormalizedPoint;
  function fixAncestors(el){
    var a = el.parentElement;
    while (a && a !== document.documentElement) {
      var cs = getComputedStyle(a);
      if (cs.transform !== 'none') a.style.transform = 'none';
      if (cs.willChange && cs.willChange !== 'auto') a.style.willChange = 'auto';
      if (cs.contain && cs.contain !== 'none') a.style.contain = 'none';
      if (cs.overflow !== 'visible' || cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
        a.style.overflow = 'visible'; a.style.overflowX = 'clip'; a.style.overflowY = 'visible';
      }
      a = a.parentElement;
    }
  }
  function init(){
    if (window.__f5init) return; window.__f5init = true;
    var howEl = document.getElementById('f5-how');
    if (howEl) fixAncestors(howEl);
    var g = window.gsap;
    if (g && window.ScrollTrigger) {
      g.registerPlugin(window.ScrollTrigger);
      var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!rm) {
        g.from('[data-f5hline]', { yPercent: 110, duration: 1.1, ease: 'power4.out', stagger: .1 });
        g.from('[data-f5hsub]', { autoAlpha: 0, y: 24, duration: .8, ease: 'power3.out', stagger: .09, delay: .45 });
        var ip = document.getElementById('f5-inkline');
        if (ip) { var L = ip.getTotalLength(); ip.style.strokeDasharray = L; ip.style.strokeDashoffset = L; g.to(ip, { strokeDashoffset: 0, duration: 1, ease: 'power2.inOut', delay: .9 }); }
        var hp = document.getElementById('f5-heropen');
        if (hp) g.from(hp, { y: 60, autoAlpha: 0, duration: 1.3, ease: 'power3.out', delay: .2 });
        g.utils.toArray('[data-f5reveal]').forEach(function(el){ g.fromTo(el, { y: 36, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .95, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } }); });
      }
      var meds = [].slice.call(document.querySelectorAll('[data-f5med]'));
      var steps = [].slice.call(document.querySelectorAll('[data-f5step]'));
      var flabel = document.getElementById('f5-flabel'), prog = document.getElementById('f5-prog');
      function turnUpdate(p){
        var si = Math.min(2, Math.floor(p * 3));
        steps.forEach(function(el, i){ var on = i === si; el.style.opacity = on ? '1' : '0.38'; el.style.borderLeftColor = on ? 'oklch(0.46 0.13 262)' : 'rgba(23,21,15,.14)'; });
        meds.forEach(function(el, i){ el.style.opacity = i === si ? '1' : '0'; if (i === si) { if (el.paused) { var pr = el.play(); if (pr) pr.catch(function(){}); } } else if (!el.paused) el.pause(); });
        if (flabel) flabel.textContent = '0' + (si + 1);
        if (prog) prog.style.transform = 'scaleX(' + Math.max(0.02, p) + ')';
      }
      if (howEl) { window.ScrollTrigger.create({ trigger: howEl, start: 'top top', end: 'bottom bottom', onUpdate: function(s){ turnUpdate(s.progress); } }); turnUpdate(0); }
      setTimeout(function(){ window.ScrollTrigger.refresh(); }, 1200);
      setTimeout(function(){
        var stick = document.getElementById('f5-how-sticky');
        if (!howEl || !stick) return;
        var probe = function(){
          var hr = howEl.getBoundingClientRect();
          if (hr.top < -100 && hr.bottom > window.innerHeight + 100) {
            var sr = stick.getBoundingClientRect();
            if (sr.top < -60 || sr.top > 60) { howEl.style.height = 'auto'; stick.style.position = 'relative'; stick.style.height = 'auto'; stick.style.padding = '110px 6vw'; window.ScrollTrigger.refresh(); window.removeEventListener('scroll', probe); }
          }
        };
        window.addEventListener('scroll', probe, { passive: true });
      }, 1500);
    } else {
      [].slice.call(document.querySelectorAll('[data-f5reveal],[data-f5hline],[data-f5hsub]')).forEach(function(el){ el.style.opacity = '1'; });
      var stick2 = document.getElementById('f5-how-sticky');
      if (howEl && stick2) { howEl.style.height = 'auto'; stick2.style.position = 'relative'; stick2.style.height = 'auto'; stick2.style.padding = '110px 6vw'; }
    }
    var ba = document.getElementById('f5-ba'), baTop = document.getElementById('f5-ba-top'), baHandle = document.getElementById('f5-ba-handle');
    if (ba && baTop && baHandle) {
      var drag = false;
      var set = function(x){ var r = ba.getBoundingClientRect(); var pct = Math.max(2, Math.min(98, ((x - r.left) / r.width) * 100)); baTop.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)'; baHandle.style.left = pct + '%'; };
      ba.addEventListener('pointerdown', function(e){ drag = true; ba.setPointerCapture(e.pointerId); set(e.clientX); });
      ba.addEventListener('pointermove', function(e){ if (drag) set(e.clientX); });
      ['pointerup','pointercancel'].forEach(function(t){ ba.addEventListener(t, function(){ drag = false; }); });
    }
    var rec = document.getElementById('f5-rec');
    if (rec) {
      if (rec.scrollWidth <= rec.clientWidth + 4) rec.style.justifyContent = 'center';
      var prev = document.getElementById('f5-rec-prev'), next = document.getElementById('f5-rec-next');
      if (prev) prev.addEventListener('click', function(){ rec.scrollBy({ left: -580, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function(){ rec.scrollBy({ left: 580, behavior: 'smooth' }); });
      [].slice.call(document.querySelectorAll('[data-f5card]')).forEach(function(card){
        card.addEventListener('click', function(){
          var v = card.querySelector('video'), ov = card.querySelector('[data-f5ov]');
          if (!v) return;
          if (v.paused) {
            [].slice.call(rec.querySelectorAll('video')).forEach(function(o){ if (o !== v && !o.paused) { o.pause(); var c = o.closest('[data-f5card]'); var oo = c && c.querySelector('[data-f5ov]'); if (oo) oo.style.opacity = '1'; } });
            v.muted = false; var pr = v.play(); if (pr) pr.catch(function(){}); if (ov) ov.style.opacity = '0';
          } else { v.pause(); if (ov) ov.style.opacity = '1'; }
        });
      });
    }
    var paper = document.getElementById('f5-paper'), phone = document.getElementById('f5-phone');
    if (paper && phone) {
      var strokes = [], cur = null, ink = '#17150f', drawing = false, replayTimer = null;
      var countEl = document.getElementById('f5-count'), inkDot = document.getElementById('f5-inkdot'), inkName = document.getElementById('f5-inkname');
      var inkNames = {}; inkNames['#17150f'] = 'INK BLACK'; inkNames['oklch(0.46 0.13 262)'] = 'OCEAN BLUE'; inkNames['oklch(0.52 0.17 25)'] = 'VERMILION';
      function sizeCanvas(c){ var r = c.getBoundingClientRect(); var d = window.devicePixelRatio || 1; c.width = r.width * d; c.height = r.height * d; c.getContext('2d').setTransform(d, 0, 0, d, 0, 0); }
      function drawAll(){
        var pc = paper.getContext('2d'), hc = phone.getContext('2d');
        var pr = paper.getBoundingClientRect(), hr = phone.getBoundingClientRect();
        pc.clearRect(0, 0, pr.width, pr.height); hc.clearRect(0, 0, hr.width, hr.height);
        strokes.concat(cur ? [cur] : []).forEach(function(st){
          [pc, hc].forEach(function(ctx, k){
            var rect = k === 0 ? pr : hr;
            ctx.strokeStyle = st.color; ctx.lineWidth = (k === 0 ? 2.4 : 2); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
            ctx.beginPath();
            st.pts.forEach(function(p, i){ var mapped = mapNormalizedPoint(p, rect), x = mapped[0], y = mapped[1]; if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y); });
            ctx.stroke();
          });
        });
        if (countEl) countEl.textContent = strokes.length + ' stroke' + (strokes.length === 1 ? '' : 's');
      }
      function pos(e){
        var r = paper.getBoundingClientRect();
        return [
          Math.max(0, Math.min(1, (e.clientX - r.left) / Math.max(r.width, 1))),
          Math.max(0, Math.min(1, (e.clientY - r.top) / Math.max(r.height, 1)))
        ];
      }
      paper.addEventListener('pointerdown', function(e){ drawing = true; paper.setPointerCapture(e.pointerId); cur = { color: ink, pts: [pos(e)] }; });
      paper.addEventListener('pointermove', function(e){ if (drawing && cur) { cur.pts.push(pos(e)); drawAll(); } });
      function up(){ if (cur) { strokes.push(cur); cur = null; } drawing = false; drawAll(); }
      paper.addEventListener('pointerup', up); paper.addEventListener('pointerleave', up);
      [].slice.call(document.querySelectorAll('[data-f5ink]')).forEach(function(b){
        b.addEventListener('click', function(){
          ink = b.getAttribute('data-f5ink');
          [].slice.call(document.querySelectorAll('[data-f5ink]')).forEach(function(o){ o.style.boxShadow = 'none'; });
          b.style.boxShadow = '0 0 0 2px #f2f0e9,0 0 0 3.5px #17150f';
          if (inkDot) inkDot.style.background = ink; if (inkName) inkName.textContent = inkNames[ink] || 'INK';
        });
      });
      var clearBtn = document.getElementById('f5-clear');
      if (clearBtn) clearBtn.addEventListener('click', function(){ strokes = []; cur = null; if (replayTimer) clearInterval(replayTimer); drawAll(); });
      var replayBtn = document.getElementById('f5-replay');
      if (replayBtn) replayBtn.addEventListener('click', function(){
        if (!strokes.length || replayTimer) return;
        var full = strokes; strokes = []; var si = 0, pi = 0; var acc = { color: full[0].color, pts: [] };
        replayTimer = setInterval(function(){
          for (var k = 0; k < 4; k++) {
            if (si >= full.length) { clearInterval(replayTimer); replayTimer = null; strokes = full; cur = null; drawAll(); return; }
            acc.pts.push(full[si].pts[pi]); pi++;
            if (pi >= full[si].pts.length) { strokes.push({ color: full[si].color, pts: acc.pts }); si++; pi = 0; acc = si < full.length ? { color: full[si].color, pts: [] } : acc; }
          }
          cur = si < full.length ? acc : null; drawAll();
        }, 16);
      });
      var ro = function(){ sizeCanvas(paper); sizeCanvas(phone); drawAll(); };
      ro(); window.addEventListener('resize', ro);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 60); });
  else setTimeout(init, 60);
  window.addEventListener('load', function(){ setTimeout(init, 60); });
})();
